// SupportRequirementService.ts
import Model from '@/core/models/Model';
import SupportRequirement from '@/modules/auth/models/SupportRequirement';
import type { Service } from '@/types/Service';
import SupportRequirement1 from '../models/SupportRequirement1';

class SupportRequirementService {
  getSupportRequirements() {
    return useAsyncData<Service[]>(
      'support-requirements',
      async () => {
        return Model.processResponse(await SupportRequirement.get()) as Service[];
      },
      { server: false }
    );
  }

  async updateSupportRequirements(services: Service[]) {
    const { data, error, execute } = useSubmit();
    await execute('support-requirements', {
      method: 'POST',
      body: { services },
    });

    return { data, error };
  }
}

class SupportRequirementServiceWithSearch {
  getSupportRequirements() {
    return useAsyncData<Service[]>(
      'support-requirements',
      async () => {
        return Model.processResponse(await SupportRequirement.get()) as Service[];
      },
      { server: false }
    );
  }

  getSupportRequirementsWithSearch(search: string) {
    return useAsyncData<Service[]>(
      'support-requirements',
      async () => {
        return Model.processResponse(await SupportRequirement.where('search', search).get()) as Service[];
      },
      { server: false }
    );
  }

  getSupportRequirementsWithSearchAndPagination({
    search,
    page,
    per_page,
  }: {
    search: string;
    page: number;
    per_page: number;
  }) {
    return useAsyncData<Service[]>(
      'support-requirements',
      async () => {
        return Model.processResponse(
          await SupportRequirement1.where('search', search).params({ page, per_page }).get()
        ) as Service[];
      },
      { server: false }
    );
  }
}

const supportRequirementService = new SupportRequirementService();
const supportRequirementServiceWithSearch = new SupportRequirementServiceWithSearch();
export { supportRequirementService, supportRequirementServiceWithSearch };

export default {
  supportRequirementService,
  supportRequirementServiceWithSearch,
};
